import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import EllipsisText from "react-ellipsis-text";
import { connect } from "react-redux";
import { isInquiryOrCart } from "../../../actions";
import {
  getCurrencySymbol,
  getColorCodeBasedOnKey,
  getValueFromLanguageObject,
  formatPrice,
} from "../../../store";
import ImageWrapper from "../../layouts/common/ImageWrapper";
import DOMPurify from "dompurify";

class WishProductListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      showErrorMessageModal: false,
      errorMessage: "",
    };
  }

  componentDidMount() {}

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  render() {
    const {
      product,
      symbol,
      isInquiry,
      onAddToCartClicked,
      wishlistId,
      onClickOfDeleteWishlist,
      isVisibleDeleteWishlist,
      masterDetailsObj,
    } = this.props;

    const {
      name: productName = "",
      price: productPrice,
      created,
      id: productId,
      productmedia,
    } = product || {};

    const strItemAdded =
      getValueFromLanguageObject("str_item_added") || "Item Added";

    const strAddToInquiry =
      getValueFromLanguageObject("str_add_to_inquiry") || "Add To Inquiry";

    const strAddToCart =
      getValueFromLanguageObject("str_add_to_cart") || "Add to cart";

    const strDelete = getValueFromLanguageObject("str_delete") || "Delete";

    const productImage =
      productmedia && productmedia.length > 0
        ? productmedia[0].productname
        : "";

    console.log("Rendering WishProductListItem for product:", productmedia);
    console.log("Product description:", product.description);

    return (
      <>
        <div className="card p-3 mb-3 product-box mt-0">
          <div className="wishlist-product">
            <div
              className="p-img position-relative mb-3 bg-light rounded overflow-hidden"
              style={{
                paddingTop: "60%",
                background: "rgb(248, 250, 252)",
                overflow: "hidden",
              }}
            >
              <Link
                to={`/singleproduct/${productId}`}
                className="d-block position-absolute w-100 h-100"
                style={{ top: 0, left: 0 }}
              >
                <ImageWrapper
                  imgUrl={productImage}
                  masterDetailsObj={masterDetailsObj}
                  className="wishlist-img w-100 h-100"
                  style={{
                    objectFit: "cover",
                  }}
                />
              </Link>
            </div>
          </div>
          <div className="product-detail w-100 flex-grow-1">
            <Link to={`/singleproduct/${productId}`}>
              <h4
                style={{
                  fontWeight: "bold",
                }}
              >
                <EllipsisText text={productName} length={35} />
              </h4>
            </Link>
            {product.category && product.category.name && (
              <div
                style={{
                  color: "color: rgb(136, 136, 136);",
                }}
                className="mt-1 mb-1"
              >
                <strong>Category:</strong> {product.category.name}
              </div>
            )}
            {!isInquiry && (
              <h4
                style={{
                  fontSize: "18px",
                  fontWeight: "700",
                  color: "rgb(18, 82, 201)",
                  marginBottom: "4px",
                  letterSpacing: "0.02em",
                }}
                className="mb-3 mt-2"
              >
                {productPrice} Points
              </h4>
            )}

            {product.description ? (
              <div className="text-dark mb-3">
                {DOMPurify.sanitize(product.description)
                  .replace(/<[^>]+>/g, "") // Remove HTML tags
                  .replace(/&nbsp;/g, " ") // Replace &nbsp; with space
                  .trim()}
              </div>
            ) : (
              <div>No description available.</div>
            )}
          </div>
          <div
            className="product_box_button"
            style={{
              marginTop: "16px",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <button
              className="btn btn-solid"
              style={{
                marginRight: "13px",
                minWidth: "120px",
              }}
              onClick={() => {
                onAddToCartClicked(product, 1);
              }}
            >
              {isInquiry ? strAddToInquiry : strAddToCart}
            </button>
            {isVisibleDeleteWishlist && (
              <button
                className="btn btn-danger"
                style={{ minWidth: "90px" }}
                onClick={() => {
                  onClickOfDeleteWishlist(wishlistId);
                }}
              >
                {strDelete}
              </button>
            )}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  isInquiry: state.settings.isInquiry,
  symbol: getCurrencySymbol(),
  masterDetailsObj: state.masterDetails.masterDetailsObj,
});

export default connect(mapStateToProps, { isInquiryOrCart: isInquiryOrCart })(
  withRouter(WishProductListItem)
);
